// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__29Sko","boxTitle":"Qualiphy_boxTitle__16_Rf","box":"Qualiphy_box__1A1hF","toggleWrap":"Qualiphy_toggleWrap__2sEZ6"};